editQuestionController.$inject = [
  '$scope', '$uibModalInstance', 'type', 'content', 'links', 'pictureId', 'videoId', 'fileId', 'fileName', 'menuChoice',
  'spellCheckerLang', 'disableInput', 'isRoot', 'companyId', 'site',
  'quickRepliesElementsConfig', 'isMessageWithChoice', 'isQuestionBox', 'summaryText', 'WhatsappFactory'];
export function editQuestionController(
  $scope, $uibModalInstance, type, content, links, pictureId, videoId, fileId, fileName, menuChoice,
  spellCheckerLang, disableInput, isRoot, companyId, site,
  quickRepliesElementsConfig, isMessageWithChoice, isQuestionBox, summaryText, WhatsappFactory) {

  $scope.noTextNorMedia = noTextNorMedia;
  $scope.editQuestion = editQuestion;
  $scope.cancel = cancel;
  $scope.isRoot = isRoot;
  $scope.quickRepliesElementsConfig = quickRepliesElementsConfig;
  $scope.question = {
    'type': type,
    'content': content,
    'links': links,
    'pictureId': pictureId,
    'videoId': videoId,
    'fileId': fileId,
    'fileName': fileName,
    'menuChoice': menuChoice,
    'spellCheckerLang': spellCheckerLang,
    'disableInput': disableInput,
    'summaryText': summaryText
  };
  $scope.editorModelAccessor = {};
  $scope.questionTextIsEmpty = false;
  $scope.companyId = companyId;
  $scope.site = site;
  $scope.isMessageWithChoice = isMessageWithChoice;
  $scope.isQuestionBox = isQuestionBox;


  function editQuestion(question) {
    const commonData = {
      'disableInput': question.disableInput,
      'menuChoice': question.menuChoice,
    };
    let data;
    const isTextMessage = !!($scope.editorModelAccessor?.getModelOfFirstMessage && $scope.editorModelAccessor.getModelOfFirstMessage());
    const isMediaMessage = question.pictureId || question.videoId;
    if (WhatsappFactory.getType() === site.type && (!isTextMessage || !isMediaMessage)) {
      // Prevent to have text + media for whatsapp due to issues in the order of incoming messages.
      data = {
        ..._getMediaMessageContent(question),
        ...commonData
      }
      if (isTextMessage) {
        data = {
          ..._getTextMessageContent(question),
          ...commonData
        };
      }
    } else {
      data = {
        ..._getTextMessageContent(question),
        ..._getMediaMessageContent(question),
        ...commonData
      }
    }
    $uibModalInstance.close({ type: 'edit', data });
  }

  function _getTextMessageContent(question) {

    let questionModel = $scope.editorModelAccessor.getModelOfFirstMessage();

    const fileAttachmentValue = questionModel.attachments.filter(a => a.type = 'file')
      .map(a => a.value)
      .find(() => true) // get the first element, or undefined if the filter didn't leave any element
    return {
      'content': questionModel['text'],
      'links': questionModel['links'],
      'fileId': fileAttachmentValue ? fileAttachmentValue.fileId : undefined,
      'fileName': fileAttachmentValue ? fileAttachmentValue.fileName : undefined,
      'spellCheckerLang': question.spellCheckerLang,
      'summaryText': question.summaryText || undefined
    };
  }

  function _getMediaMessageContent(question) {
    return {
      'pictureId': question.pictureId,
      'videoId': question.videoId,
    };
  }

  function cancel() {
    $uibModalInstance.dismiss('cancel');
  }

  function noTextNorMedia() {
    let hasAttachment = false;
    try {
      // no guarantee that the model accessor has been inited by editor2 yet
      hasAttachment = $scope.editorModelAccessor.getModelOfFirstMessage().attachments.length > 0;
    } catch (e) {
      // there aren't any attachment
    }
    return $scope.questionTextIsEmpty && !$scope.question.pictureId && !$scope.question.videoId && !hasAttachment;

  }

}
